import { z } from 'zod'

export const serviceLoadTypeSchema = z.object({
  id: z.number().optional(),
  name: z.string().min(1, 'Load type name is required'),
  loadTypeId: z.number().optional(),
  serviceId: z.number().optional(),
})

export const serviceSchema = z.object({
  id: z.number().optional(),
  tenantId: z.number(),
  name: z.string()
    .min(1, 'Name is required')
    .max(50, 'Name must not exceed 50 characters'),
  description: z.string()
    .max(200, 'Description must not exceed 200 characters'),
  code: z.string()
    .min(1, 'Code is required')
    .max(50, 'Code must not exceed 50 characters'),
  customerSelectable: z.boolean().default(false),
  enabled: z.boolean().default(true),
  inUse: z.boolean().optional(),
  loadTypes: z.array(serviceLoadTypeSchema)
    .default([])
    .refine((loadTypes) => {
      const loadTypeIds = loadTypes.map(lt => lt.loadTypeId).filter(Boolean);
      const uniqueIds = new Set(loadTypeIds);
      return uniqueIds.size === loadTypeIds.length;
    }, {
      message: 'Duplicate load types are not allowed'
    }),
})

export type ServiceFormData = z.infer<typeof serviceSchema>
export type ServiceLoadTypeFormData = z.infer<typeof serviceLoadTypeSchema>
